import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux/store';
import { Bank } from './views/Bank';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<Bank />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Bank)
	.build();

export default Layout;
